export function firstAvailable(items: any[], condition = (x) => x !== undefined) {
    return items.find(condition);
}

export default firstAvailable;
